/**
 * Build-time feature flags (per-environment, set via REACT_APP_* env files).
 * Read at call time so tests can toggle them.
 */

/**
 * Rates features released after prod-10 (default inspector rates, custom
 * days toggle, days auto-populate). OFF unless REACT_APP_RATES_FEATURES=true.
 */
export const ratesFeaturesEnabled = (): boolean =>
  process.env.REACT_APP_RATES_FEATURES === "true";
